import React from 'react';

export const CONTACT_STATUS_LABELS = {
    not_contacted: 'Not Contacted', queued: 'Queued', sent: 'Sent', replied: 'Replied',
    follow_up: 'Follow-up', interested: 'Interested', not_interested: 'Not Interested',
    bounced: 'Bounced', do_not_contact: 'Do Not Contact',
};

export const CONTACT_STATUS_ORDER = ['not_contacted', 'queued', 'sent', 'replied', 'follow_up', 'interested', 'not_interested', 'bounced', 'do_not_contact'];

const CONTACT_STATUS_TONE = {
    not_contacted: 'bg-slate-50 text-slate-500 border-slate-200',
    queued: 'bg-sky-50 text-sky-700 border-sky-200',
    sent: 'bg-indigo-50 text-indigo-700 border-indigo-200',
    replied: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    follow_up: 'bg-amber-50 text-amber-700 border-amber-200',
    interested: 'bg-teal-50 text-teal-700 border-teal-200',
    not_interested: 'bg-slate-100 text-slate-500 border-slate-200',
    bounced: 'bg-red-50 text-red-700 border-red-200',
    do_not_contact: 'bg-red-100 text-red-800 border-red-300',
};

export function ContactStatusBadge({ status, testId }) {
    const s = status || 'not_contacted';
    return (
        <span className={`text-[10.5px] font-semibold uppercase tracking-wide px-2 py-1 rounded border ${CONTACT_STATUS_TONE[s] || CONTACT_STATUS_TONE.not_contacted}`} data-testid={testId}>
            {CONTACT_STATUS_LABELS[s] || s}
        </span>
    );
}

export function EmailStatusBadge({ status, confidence, testId }) {
    if (!status) return <span className="text-[color:var(--bm-text-subtle)] text-[12px]">—</span>;
    const isVerified = status.toUpperCase().startsWith('VERIFIED');
    return (
        <span className={`inline-flex items-center gap-1 text-[10.5px] font-semibold uppercase tracking-wide px-2 py-1 rounded border ${isVerified ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-amber-50 text-amber-700 border-amber-200'}`}
              title={isVerified ? undefined : 'Validation recommended before sending'} data-testid={testId}>
            {status}{confidence != null && !isVerified && <span className="opacity-70">({confidence}%)</span>}
        </span>
    );
}
